//axios设置
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { UserModule } from "@/store/modules/user";
import router from "@/router";
import Cookies from "js-cookie";
function blob2Json(res) {
  return new Promise((resolve, reject) => {
    try {
      const fileReader = new FileReader()
      fileReader.onload = function (e: any) {
        let result = e[`target`]!.result
        const jsonData = JSON.parse(result)
        resolve(jsonData)
      }
      fileReader.readAsText(res)
    } catch (err) {
      reject(err)
    }
  })
}

const isIEBrowser = !!(window as any).ActiveXObject || "ActiveXObject" in window;

const service: AxiosInstance = axios.create({
  // baseURL: window.config.baseUrl,
  baseURL: window.config.baseUrl4Shool, // 飞泉接口地址/专家管理主项目地址
  timeout: window.config.timeout
});

//添加请求拦截器
service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    //给每个请求头部添加 access_token
    if (UserModule.token) {
      config.headers["access_token"] = UserModule.token;
      // config.headers["access_token"] = JSON.stringify(UserModule.token);
      // config.headers["x-client-token-user"] =UserModule.token
    }

    //如果是get请求，参数如果是空字符串，则不再拼接
    if (config.method === "get") {
      for (let k in config.params) {
        if (config.params[k] === "") {
          config.params[k] = null;
        }
      }
      // 如果IE浏览器url固定则添加时间戳
      if ((config as any).url.indexOf('?') === -1 && isIEBrowser) {
        (config as any).url += `?timestamp=${+new Date()}`
      }
    }
    return config;
  },
  (error: any) => {
    Promise.reject(error);
  }
);

//添加响应拦截器
service.interceptors.response.use(
  async (res: AxiosResponse) => {
    // 前端简单的更新菜单加载标识 isLoadMenu 在cookies的失效时间
    let updateCurrentTime = new Date(res.data.timestamp).getTime() + 60 * 1000 * 60;
    Cookies.set("isLoadMenu", "yes", { expires: updateCurrentTime })
    // 对blob类型请求返回的错误消息进行特殊处理
    if (res.data instanceof Blob && (res.data.type === "application/json")) {
      const errorJson = await blob2Json(res.data)
      return Promise.reject(errorJson)
    }
    if (res.status === 200) {
      let code = res.data.code;
      // 20000000 表示接口返回成功   "Blob"，表示下载类型的资源（没有返回code）
      if (code === "20000000" || res.data instanceof Blob || res.data.type == 'application/pdf') {
        return Promise.resolve(res.data);
      } else if (code === "20010003" || code === "20010004" || code === "20000001") {
        UserModule.ResetToken();  // 20010003 无token，请重新登录 // 20010004 当前用户已掉线 // 20000001 无效token
        setTimeout(() => {
          router.push({ path: "/" });
        }, 2500);
        return Promise.reject(res.data);
      }
      else if (code === "20000500" || code === "20080041" || code === "20020000") {
        return Promise.reject(res.data[`mesg`])
      }
      else {
        return Promise.reject(res.data.mesg); // 其实是同一个东西
      }
    } else if (res.status === 401) {
      UserModule.ResetToken();
      setTimeout(() => {
        router.push({ path: "/" });
      }, 1500);
      return Promise.reject(res.data);
    } else {
      return Promise.reject(res.data);
    }
  },
  (error: any) => {
    if (error.response && error.response.status === 401) {
      UserModule.ResetToken();
      setTimeout(() => {
        router.push({ path: "/" });
      }, 1500);
    }
    return Promise.reject(error.response.data || error);
  }
);

export default service;
